import { theme } from '@theme';
import { FC } from 'react';
import styled from 'styled-components';
import { ButtonWrapper } from '../../style/ButtonWrapper';

type ButtonProps = {
  color?: string;
  backgroundColor?: string;
  text: string;
  fontSize?: number;
  width?: number; // in %
  disabled?: boolean;
  wrapperBackgroundColor?: string;
  fontWeight?: number;
  outerPadding?: string;
  innerPadding?: string;
  textAlign?: string;
  borderRadius?: number;
  borderColor?: string;
  outerMargin?: string;
  height?: number;
  justifyContent?: string;
  display?: string;
  containerWidth?: string;
  onClick: () => void;
};

const ButtonComponent: FC<ButtonProps> = (props) => {
  return (
    <Wrapper
      width={props.containerWidth}
      display={props.display}
      wrapperBackgroundColor={props.wrapperBackgroundColor}
      padding={props.outerPadding}
      margin={props.outerMargin}
    >
      <ButtonWrapper
        className={`form-control ${props.disabled ? 'button-link-disabled' : ''}`}
        backgroundColor={props.backgroundColor ?? theme.palette.white}
        color={props.color ?? theme.palette.black}
        width={props.width ?? 100}
        size={props.fontSize ?? theme.typography.fontSize}
        fontWeight={props.fontWeight}
        textAlign={props.textAlign}
        borderRadius={props.borderRadius}
        onClick={props.onClick}
        data-testid='button'
        padding={props.innerPadding}
        borderColor={props.borderColor}
        height={props.height}
        justifyContent={props.justifyContent}
        display={'inline-block'}
      >
        <span className='button-text'>{props.text}</span>
      </ButtonWrapper>
    </Wrapper>
  );
};

export default ButtonComponent;

type WrapperProps = {
  wrapperBackgroundColor?: string;
  padding?: string;
  margin?: string;
  display?: string;
  width?: string;
};

const Wrapper = styled.div<WrapperProps>`
  background-color: ${(props) => props.wrapperBackgroundColor ?? props.theme.palette.white};
  padding: ${(props) => props.padding ?? '2px 7px'};
  cursor: pointer;
  margin: ${(props) => props.margin};
  display: ${(props) => props.display};
  width: ${(props) => props.width}%;
`;
